import React from 'react';
import { Container, Card } from 'react-bootstrap';
import Header from '~/Components/Header/Header';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';
import TabAnexar from './TabAnexar';

const Digitalizacao = () => {
  const temPermissaoSupervisor = AuthStorage.temCaracteristicas([caracteristicas.SupervisorGED]);

  return (
    <Container fluid>
      <Header title="Digitalização" />
      <Card className="mt-3">
        <Card.Body>
          <TabAnexar temPermissaoSupervisor={temPermissaoSupervisor} />
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Digitalizacao;
